/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleRequest,
  getCoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleRequestErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleRequest';
import {
  CoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleResponse,
  getCoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleResponse';

export type CreateConsensusRuleArgs = {
  /**
   * entity_id is the rule scope: a legal entity id, an organization id, or
"personal:{userId}". The scope kind is implied by resource_type.
   */
  entityId: string;
};

type AllCreateConsensusRuleMutationArgs =
  CoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleRequest;
export type CreateConsensusRuleMutationArgs = Omit<AllCreateConsensusRuleMutationArgs, 'entityId'>;

export type CreateConsensusRuleResult =
  CoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleResponse;

const validateCreateConsensusRuleResult = (value: unknown) => {
  const errors = getCoinbaseEngUsersAccountManagementApiApiCreateConsensusRuleResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: CreateConsensusRuleResult data does not match contract.`,
      errors,
    );
  }
};

type HookReturnType = (
  params: CreateConsensusRuleArgs,
  payload: Readonly<CreateConsensusRuleMutationArgs>,
  options?: RequestInit,
) => Promise<CreateConsensusRuleResult | ErrorTypes>;

export const getCreateConsensusRuleUrl = (params: CreateConsensusRuleArgs) => {
  const searchParams = new URLSearchParams();
  const url = `${getBaseUrl()}/v1/consensus/entities/${params.entityId}/rules${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Post CreateConsensusRule
 * @Url /v1/consensus/entities/{entity_id}/rules
 * @Auth Required
 */
export const useCreateConsensusRule = (): HookReturnType => {
  const mutation = useMutation<unknown, CreateConsensusRuleResult>();

  const callback = useCallback(
    async (
      params: CreateConsensusRuleArgs,
      payload: Readonly<CreateConsensusRuleMutationArgs>,
      options?: RequestInit,
    ) => {
      const postBody = {
        product: payload.product,
        resource_type: payload.resourceType,
        resource_id: payload.resourceId,
        action: payload.action,
        required_approvals: payload.requiredApprovals,
        consensus_2fa_type: payload.consensus2faType,
        rule_name: payload.ruleName,
        approver_roles: payload.approverRoles,
      };

      const init = { ...(options || {}), method: 'POST' };

      const url = getCreateConsensusRuleUrl(params);
      const result = await mutation(url, postBody, init);
      if (process.env.NODE_ENV !== 'production') {
        validateCreateConsensusRuleResult(result);
      }
      return result;
    },
    [mutation],
  );

  return callback;
};
